import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CsIconModule } from '@components/icon';
import { HttpClientModule } from '@angular/common/http';
import { LoadingModule } from '@components/loading';
import { ButtonModule } from '@components/button';
import { TranslateStringsModule } from '@components/translate-string';
import { ReAcquisitionTakePhotoComponent } from './re-acquisition-take-photo/re-acquisition-take-photo.component';
import { ReAcquisitionUserQueryComponent } from './re-acquisition-user-query/re-acquisition-user-query.component';
import { ReAcquisitionUserWaitingForCallComponent } from './re-acquisition-waiting-for-call/re-acquisition-waiting-for-call.component';
import { RegimenConcernSelectionModule } from '@shared/regimen-concern-selection/regimen-concern-selection.module';
import { ReAcquisitionConcernSelectionComponent } from './re-acquisition-concern-selection/re-acquisition-concern-selection.component';
import { ReAcquisitionUserQueryV2Component } from './re-acquisition-user-query-v2/re-acquisition-user-query-v2.component';
import { WaitingForCallComponent } from '@shared/waiting-for-call/waiting-for-call.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CsIconModule,
    ReactiveFormsModule,
    HttpClientModule,
    LoadingModule,
    ButtonModule,
    RegimenConcernSelectionModule,
    WaitingForCallComponent,
    TranslateStringsModule,
    RouterModule.forChild([{
      path: 're-acquisition',
      canActivate: [],
      children: [
        {
          path: 'take-photo',
          component: ReAcquisitionTakePhotoComponent,
        },
        {
          path: 'user-query',
          component: ReAcquisitionUserQueryComponent,
        },
        {
          path: 'waiting-for-call',
          component: ReAcquisitionUserWaitingForCallComponent,
        },
        {
          path: 'concern-selection',
          component: ReAcquisitionConcernSelectionComponent,
        },
        {
          path: 'user-query-v2',
          component: ReAcquisitionUserQueryV2Component,
        }
      ],
    }]),
  ],
  declarations: [
    ReAcquisitionTakePhotoComponent,
    ReAcquisitionUserQueryComponent,
    ReAcquisitionUserWaitingForCallComponent,
  ],
})
export class ReAcquisitionModule { }
